// src/hooks/useAccordionDoubleClick.js
import { useEffect } from "react";

const useAccordionDoubleClick = ({ openAccordions, setOpenAccordions }) => {
  useEffect(() => {
    const handleDoubleClick = (e) => {
      const label = e.target.closest("label");
      if (!label) return;

      const forId = label.getAttribute("for");
      if (!forId) return;

      const input = document.getElementById(forId);
      if (!input || input.type !== "checkbox") return;

      // collect all ancestor‐accordion keys
      const ancestorKeys = [];
      let currentLi = label.closest("li");
      while (currentLi) {
        const parentContent = currentLi.closest(".accordian__content");
        if (!parentContent) break;

        const parentLi = parentContent.closest("li");
        if (!parentLi) break;

        // ← Use :scope to select *direct* child
        const parentInput = parentLi.querySelector(":scope > input[type='checkbox']");
        if (!parentInput) break;

        const key = parentInput.id.replace(/^Indiv-Haven-KJ-/, "");
        ancestorKeys.push(key);

        currentLi = parentLi;
      }

      // close just those ancestors
      setOpenAccordions((prev) => {
        const updated = { ...prev };
        ancestorKeys.forEach((k) => {
          updated[k] = false;
        });
        sessionStorage.setItem("havenKJAccordionState", JSON.stringify(updated));
        return updated;
      });
    };

    document.addEventListener("dblclick", handleDoubleClick);
    return () => document.removeEventListener("dblclick", handleDoubleClick);
  }, [openAccordions, setOpenAccordions]);
};

export default useAccordionDoubleClick;
